import apiManager from "../index";
import fetchErrorHandler from "../../error";

const getApplications = async (params) => {
  const response = await apiManager.getApplications({ params: params });
  if (response.status !== 200) {
    fetchErrorHandler(response.status, response.statusText, this.$options.name);
    return [];
  } else {
    return response.parsedData.applications;
  }
};

const formatResponse = (applications) => {
  return applications.map((item) => {
    return {
      pk: item.pk,
      name: item.name,
      isDeleted: item.is_deleted,
    };
  });
};

const getApplication = async (params) => {
  const applications = await getApplications(params);
  return new Promise((resolve) => resolve(((applications) => formatResponse(applications))(applications)));
};

export default getApplication;
